import dayjs from 'dayjs';
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat);

Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.UploaderValidation = Marionette.Behavior.extend({
        events: {
            'click #done': 'clickDone'
        },
        clickDone: function() {
            var valid = true;
            var _this = this;
            this.view.ui.nameInput.find('.error').hide();
            //email
            this.view.ui.emailInput.find('.error').hide();
            this.view.ui.emailInput.find('.validate').hide();
            // dob
            this.view.ui.dobInput.find('.error').hide();

            if (this.view.ui.dobInput.is(':visible')) {
                var m = dayjs(this.view.ui.dobInputText.val(), 'MM-DD-YYYY', true);
                if (m.isValid()) {
                    this.view.model.set('dob', this.view.ui.dobInputText.val());
                } else {
                    this.view.ui.dobInput.find('.error').show();
                    valid = false;
                }
            }
            if (!_.isFalsy(this.view.ui.fullNameInputText.val())) {
                if (this.view.options.source === 'facebook') {
                    this.view.model.set('facebook_user_name', this.view.ui.fullNameInputText.val());
                }
                this.view.model.set('full_name', this.view.ui.fullNameInputText.val());
            } else {
                this.view.ui.nameInput.find('.error').show();
                valid = false;
            }
            if (!_.isFalsy(this.view.ui.emailInputText.val())) {
                var re = /\S+@\S+\.\S+/;
                if (!re.test(this.view.ui.emailInputText.val())) {
                    this.view.ui.emailInput.find('.validate').show();
                    valid = false;
                } else {
                    this.view.ui.emailInput.find('.validate').hide();
                    this.view.model.set('email_address', this.view.ui.emailInputText.val());
                }
            } else {
                this.view.ui.emailInput.find('.error').show();
                valid = false;
            }
            if (this.view.ui.clientTosHolder.is(':visible')) {
                if (!this.view.ui.clientTosCheckbox.is(':checked')) {
                    valid = false;
                    this.view.ui.clientTosHolder.find('.error').show();
                } else {
                    this.view.ui.clientTosHolder.find('.error').hide();
                }
            }

            if ($('.additional_tos_input').length > 0) {
                $('.additional_tos_input').each(function() {
                    var input = $(this).find('input');
                    if (!input.is(':checked')) {
                        valid = false;
                        $(this).find('.error').show();
                    } else {
                        $(this).find('.error').hide();
                    }
                });

            }

            this.view.ui.additionalField.each(function() {
                var isRequired = $(this).hasClass('required');
                if (!_.isFalsy($(this).find('.additional_input').val())) {
                    $(this).find('.error').hide();
                    _this.view.model.set($(this).find('label').html(), $(this).find('.additional_input').val());
                } else if (isRequired) {
                    valid = false;
                    $(this).find('.error').show();
                }
            });

            if (valid) {
                this.view.triggerMethod('validation:success');
            }
        }
    });

});
